import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { Button } from 'reactstrap'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'

import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import SupportForm from '../../components/Form/SupportForm/SupportForm'
import Loader from '../../components/Loader/Loader'
import TagCloud from '../../components/Support/V2/TagCloud'
import TagCloudItemGroup from '../../components/Support/V2/TagCloudItemGroup'

import { supportActions } from '../../redux/actions/index'
import faqActions from '../../redux/actions/faq.actions'
import { currentUser } from '../../redux/reducers/user.reducers'

import support from '../../services/support.service'

import './SupportV2.scss'

const FAQ_USER_PATH = 'amd_faq_user_path'
const DEFAULT_FAQ_CATEGORY_ID = 1

class SupportV2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lastFaqCategoryId: null,
      showActiveFaqState: false,
      viewedFaqState: false, // if user has viewed faq or not
    }
    this._isMounted = false
  }

  async componentDidMount() {
    this._isMounted = true
    const { getSuggestions, getFaqs, getFaqsCategories, getFaqTagCloud } = this.props
    await getFaqs()
    await getSuggestions()
    await getFaqsCategories()
    await getFaqTagCloud()
    if (this._isMounted) {
      this.getlastFaqCategory()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getlastFaqCategory() {
    const storedFaqCategoryId = window.localStorage.getItem(FAQ_USER_PATH)
    const lastFaqCategory = storedFaqCategoryId ? JSON.parse(storedFaqCategoryId) : null
    const lastFaqCategoryId = lastFaqCategory && lastFaqCategory.id

    if (lastFaqCategory) {
      this.setState({
        lastFaqCategoryId,
      })
      return
    }

    this.setState({
      lastFaqCategoryId: DEFAULT_FAQ_CATEGORY_ID,
    })
  }

  handleFaq = async lastFaqCategoryId => {
    window.localStorage.setItem(FAQ_USER_PATH, JSON.stringify({ id: lastFaqCategoryId }))
    this.setState({
      lastFaqCategoryId,
      showActiveFaqState: true,
    })
  }

  handleInitialSupportBtn = () => {
    this.setState({
      viewedFaqState: true,
    })
  }

  handleFaqLog = async faqId => {
    const { saveFaqLog, user } = this.props
    const payload = {
      faqId,
      userId: user.id,
      source: 'support',
    }
    await saveFaqLog(payload)
  }

  renderSupportDescription() {
    return (
      <>
        <h1 className="page-title" aria-label="Support">
          <FormattedMessage id="page.supportPage.title.heroTitle" />
        </h1>
        <h4 aria-level="2">
          <FormattedHTMLMessage id="page.supportPage.title.description1" />
        </h4>
      </>
    )
  }

  renderSupportFaqItems() {
    const { supportLoading, faqLoading, faqCategories, faqs } = this.props
    const { lastFaqCategoryId, showActiveFaqState } = this.state

    if (supportLoading || faqLoading) {
      return <Loader aria-live="polite" />
    }
    return (
      <>
        <div className="SupportTagCloud__container" role="region" aria-label="FAQ Tag Cloud">
          <TagCloud
            activeTab={lastFaqCategoryId}
            showActiveState={showActiveFaqState}
            tagCloud={faqCategories}
            handleTag={this.handleFaq}
            componentName="SupportTagCloud"
          />
        </div>
        <TagCloudItemGroup
          categories={faqCategories}
          faqs={faqs}
          lastFaqCategoryId={lastFaqCategoryId || null}
          showResults={showActiveFaqState}
          handleFaqLog={this.handleFaqLog}
        />
        <Button
          name=""
          type="submit"
          outline
          color="dark"
          className="mt-5"
          onClick={this.handleInitialSupportBtn}
          aria-label="Next"
        >
          <FormattedMessage id="global.label.next" />
        </Button>
      </>
    )
  }

  renderSupportForm() {
    const { user, supportContent, supportLoading } = this.props

    return (
      <div className="row" role="form" aria-label="Support Form">
        <div className="col-lg-12 mt-3">
          <SupportForm
            onSubmit={support.handleTicket}
            onChange={this.handleChange}
            user={user}
            supportContent={supportContent}
            supportLoading={supportLoading}
            handleFaq={this.handleFaq}
          />
        </div>
      </div>
    )
  }

  render() {
    const { intl } = this.props
    const { viewedFaqState } = this.state
    const label = intl.formatMessage({ id: 'page.supportPage.title.heroTitle' })

    return (
      <div className="support-page" role="main" aria-label="Support Main">
        <Helmet>
          <title>{label}</title>
          <meta name="description" content="your description" />
        </Helmet>
        <div className="container mt-5 mb-5">
          {this.renderSupportDescription()}
          {!viewedFaqState ? this.renderSupportFaqItems() : this.renderSupportForm()}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getSuggestions: () => dispatch(supportActions.getSuggestions()),
  setActiveSuggestion: (...args) => dispatch(supportActions.setActiveSuggestion(...args)),
  getFaqs: () => dispatch(faqActions.getFaqs()),
  getFaqsCategories: () => dispatch(faqActions.getFaqsCategories()),
  getFaqTagCloud: () => dispatch(faqActions.getFaqTagCloud()),
  setActiveFaq: (...args) => dispatch(faqActions.setActiveFaq(...args)),
  saveFaqLog: (...args) => dispatch(faqActions.saveFaqLog(...args)),
})

const mapStateToProps = state => ({
  user: currentUser(state),
  faqLoading: state.faqReducer.faqLoading,
  faqs: state.faqReducer.faq,
  supportContent: state.supportReducer.supportContent,
  supportLoading: state.supportReducer.supportLoading,
  faqCategories: state.faqReducer.faqCategories,
  tagCloud: state.faqReducer.tagCloud,
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SupportV2))
